export default 
{
  methods: {
    async getPermissions() {

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "user_permission_get.php",
        data: {
          user_id : this.$store.state.user_obj.user_id
        }
      });

      return response.data;
    },

    async getChannelsByClient(client_id) {

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "channel_get.php",
        data: {
          client_id : client_id
        }
      });

      return response.data;
    },

    async getChannels() {

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "channel_get.php",
        data: {
          client_id : this.$store.state.user_obj.client_id,
          // account_type : this.$store.state.user_obj.account_type
        }
      });

      return response.data;
    },

    async getCollectionStores() {

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "collection_store_get.php",
        data: {
          client_id : this.$store.state.user_obj.client_id
        }
      });

      return response.data;
    },

    async getDistricts() {

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "district_get.php",
        data: {
          client_id : this.$store.state.user_obj.client_id
        }
      });

      return response.data;
    },

    async getClients() {

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "client_profile_get.php",
        data: {
          client_id : this.$store.state.user_obj.client_id
        }
      });

      return response.data;
    },

    async getClients_old() {

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "client_get.php",
        data: {
        }
      });

      return response.data;
    },

    async getTrackingRoutes() {

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_route_get.php",
        data: {
          client_id : this.$store.state.user_obj.client_id
        }
      });

      return response.data;
    },
  }
}


// WEBPACK FOOTER //
// ./src/services/ApiService.js